import React from "react";
import AdministrationCash from "../../features/administrationcash";

const ApplicationsCashPage = () => <AdministrationCash />

export default ApplicationsCashPage;